import { createApi } from "@reduxjs/toolkit/query/react";
import type { Draft } from "immer";
import { ApiEndpoints, baseQueryWithAuth } from "../../core";

export const subscriptionBillingApi = createApi({
  reducerPath: "subscriptionBillingApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["SubscriptionBilling", "SubscriptionBillings"],

  endpoints: (builder) => ({
    getBillingData: builder.query<any, { page?: number; limit?: number; organisation?: string } | void>({
      query: (params) => ({
        url: ApiEndpoints.getSubscriptionInvoice,
        method: "GET",
        params: params || undefined,
      }),
      transformResponse: (response: any) => response,
      providesTags: (result, error, args) => [
        { type: "SubscriptionBilling", id: args?.organisation ?? "LIST" },
      ],
    }),
    getBillingDataUpcoming: builder.query<any, { organisation?: string } | void>({
      query: (params) => ({
        url: ApiEndpoints.getSubscriptionInvoiceUpcoming + "/" + params?.organisation,
        method: "GET",
      }),
      transformResponse: (response: any) => response,
      extraOptions: { hideToast: true },
      providesTags: (result, error, args) => [
        { type: "SubscriptionBillings", id: args?.organisation ?? "LIST" },
      ],
    }),
  }),
});
export const { useGetBillingDataQuery,useGetBillingDataUpcomingQuery } = subscriptionBillingApi;
